import { ARM_ROWS, armFor } from "./arms.js";
// The template is copy only: the evidence rows come from the tick's own readings in compose.
export function momentCard(capability) {
    const spec = armFor(capability);
    return {
        capability,
        rung: spec.rung,
        action: spec.action,
        eyebrow: spec.eyebrow,
        watching: [],
        ...spec.template,
    };
}
export const MOMENT_CARDS = ARM_ROWS.map((s) => momentCard(s.capability));
//# sourceMappingURL=cards.js.map